import React, { FC, useState } from 'react';

import { Alert, Button, Checkbox, Label } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import { newsSubscribe, newsUnsubscribe, subscribe, unsubscribe } from 'client/api';
import { Field } from 'client/blocks-redesign/form/Field/Field';
import { IndexLayout } from 'client/blocks-redesign/Layout/Layout';
import { getSpamAgreement } from 'client/lib/gdpr-texts';
import * as keyset from 'i18n/GeneralSettings';

import styles from './UserSettingsPage.module.scss';

const t = i18n(keyset);

export const UserSettingsPage: FC = () => {
    const [isUpdating, setIsUpdating] = useState(false);
    const [isError, setIsError] = useState(false);
    const [hasSubscription, setHasSubscription] = useState(__appConfig.user.hasSubscription);
    const [hasNewsSubscription, setHasNewsSubscription] = useState(__appConfig.user.hasNewsSubscription);

    const onSubscriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setHasSubscription(e.target.checked);
        setIsError(false);
    };
    const onNewsSubscriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setHasNewsSubscription(e.target.checked);
        setIsError(false);
    };

    const onSave = async () => {
        if (isUpdating) {
            return;
        }

        setIsError(false);
        setIsUpdating(true);

        try {
            if (__appConfig.user.hasSubscription !== hasSubscription) {
                const handler = hasSubscription ? subscribe : unsubscribe;
                await handler();
                __appConfig.user.hasSubscription = hasSubscription;
            }
            if (__appConfig.user.hasNewsSubscription !== hasNewsSubscription) {
                const handlerNews = hasNewsSubscription ? newsSubscribe : newsUnsubscribe;
                await handlerNews();
                __appConfig.user.hasNewsSubscription = hasNewsSubscription;
            }
        } catch (_e) {
            setIsError(true);
        } finally {
            setIsUpdating(false);
        }
    };

    console.log('@render UserSettings');

    return (
        <IndexLayout>
            <div className={styles.userSettings__container}>
                <header className={styles.userSettings__header}>
                    <h1 className={styles.userSettings__title}>{t('header-settings')}</h1>
                    <div className={styles.userSettings__saveButtonContainer}>
                        <Button
                            className={styles.userSettings__saveButton}
                            disabled={isUpdating}
                            onClick={onSave}
                            loading={isUpdating}
                            size="l"
                            view="action"
                        >
                            {t('button-save')}
                        </Button>
                        {isError && <Label theme="danger">{t('error')}</Label>}
                    </div>
                </header>
                <Field fieldTitle={t('header-email')}>
                    <Checkbox
                        className={styles.userSettings__fieldElement}
                        checked={hasSubscription}
                        onChange={onSubscriptionChange}
                        size="l"
                        disabled={isUpdating}
                    >
                        {t('checkbox-notifications')}
                    </Checkbox>

                    <Checkbox
                        className={styles.userSettings__fieldElement}
                        checked={hasNewsSubscription}
                        onChange={onNewsSubscriptionChange}
                        size="l"
                        disabled={isUpdating}
                    >
                        {t('checkbox-global-message')}
                    </Checkbox>
                    <Alert className={styles.userSettings__fieldElement} message={<div>{getSpamAgreement()}</div>} />
                </Field>
            </div>
        </IndexLayout>
    );
};
